import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=71bc7e7a&scoped=true"
import script from "./Landing.vue?vue&type=script&lang=js"
export * from "./Landing.vue?vue&type=script&lang=js"
import style0 from "./Landing.vue?vue&type=style&index=0&id=71bc7e7a&prod&lang=scss&scoped=true"
import style1 from "./Landing.vue?vue&type=style&index=1&id=71bc7e7a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bc7e7a",
  null
  
)

export default component.exports